module.exports = {"id":"159986","name":"Lorenzo Cinterio","rating":"72","photo":"./data/images/photos/4/159986.png","club":{"name":"CD O'Higgins","logo":"./data/images/clubs/CDO'Higgins.png"},"positions":["MD","BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LorenzoCinterio0.json
// module id = 2529
// module chunks = 0